import { createFileRoute } from '@tanstack/react-router';
import { ChainList } from '@/pages/super-admin/chain-list';

export const Route = createFileRoute('/_authenticated/super-admin/chains/')({
	component: ChainList,
});
